/**
 * Wabunka体験セクションの取得に使用する Composable
 * Page でのみ使用可能
 */

import { WabunkaExperienceSectionListResponse } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_section';

import { useAsyncDataRequestStatus, useAsyncFetchFromPublicApi } from '@/wabunka-src/common/composables';
import { useCurrency } from '@/wabunka-src/common/composables/general/useCurrency/useCurrency';
import { buildExperienceSectionListViewModel } from '@/wabunka-src/features/Experience';

export const useGetExperienceSectionsQuery = async (webPagePath: string, webSectionIds: string[]) => {
  const path = computed(() => `/experienceSections`);
  const { selectedCurrency } = useCurrency();
  const { data, status, refresh } = await useAsyncFetchFromPublicApi<WabunkaExperienceSectionListResponse>({
    path,
    options: { server: true, immediate: true, watch: [selectedCurrency] },
    query: computed(() => ({
      includes: 'experiences,webPages,experienceImages,experienceTags',
      webPagePath: webPagePath,
      webSectionIds: webSectionIds.join(','),
      currency: selectedCurrency.value !== 'JPY' ? selectedCurrency.value : undefined,
    })),
    converter: WabunkaExperienceSectionListResponse.fromJSON,
  });

  const experienceSections = computed(() => buildExperienceSectionListViewModel(data.value));

  return { experienceSections, ...useAsyncDataRequestStatus(status), refresh };
};
